import React from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  IconButton,
  Stack,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { Icons } from '@marageti/z4-lib';
import InfiniteTravelersList from '../../components/infinite-traveler-list';

const TravelersView = () => (
  <Container maxWidth="xl">
    <Box py={3}>

      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography component="h1" variant="h2">
          Travelers
        </Typography>
        <Stack spacing={1} direction="row">
          <Button
            variant="outlined"
            aria-label="merge travelers"
            component={Link}
            to="/tools/merge-travelers"
            role="button"
            sx={{
              minWidth: 'fit-content',
            }}
          >
            Merge
          </Button>
          <Button
            variant="contained"
            aria-label="create account"
            component={Link}
            to="create-account"
            role="button"
            sx={{
              minWidth: 'fit-content',
              display: { xs: 'none', md: 'block' },
            }}
          >
            Create Account
          </Button>

        </Stack>

        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <IconButton
            component={Link}
            to="create-account"
          >
            <Icons.PlusCircleOutlined color="primary" />
          </IconButton>
        </Box>
      </Stack>
      <InfiniteTravelersList />
    </Box>
  </Container>
);

export default TravelersView;
